export const SERVER_DOWN_ERROR =
    'Error : Server down! Please try again after some time!';

export const PLEASE_PROVIDE_VALID = 'Please provide valid ';
export const PLEASE_SELECT_VALID = 'Please select valid ';

export const MESSAGE_CLOSE_AFTER = 2 * 1000;

export const EMPLOYEE_ROLE_ID = 3;
